const daytMap = {
  '1': '週一',
  '2': '週二',
  '3': '週三',
  '4': '週四',
  '5': '週五',
  '6': '週六',
  '7': '週日',
};

export default function formatDay(day) {
  return daytMap[day.toString()]
}
